// Environment.ts

export class Environment {
    static get(key: string, defaultValue: string = ''): string {
        return process.env[key] ?? defaultValue;
    }
}